<template>
    <div v-if="show" class="overlay" @click="closeOverlay">
      <div class="overlay-content" @click.stop>
        <p class="step">
          <span class="circle">1</span>
          <span class="text">
            点击右上角
            <img src="@/assets/gengduo.png" alt="省略号" class="icon" />
            <!-- <svg class="arrow" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M16 12L12 8V16H8L12 20L16 16V8Z" fill="#FFFFFF"/>
            </svg> -->
          </span>
        </p>
        <p class="step">
          <span class="circle">2</span>
          <span class="text">
            选择
            <img src="@/assets/safari-icon.png" alt="Safari Icon" class="icon" />
            用Safari打开
          </span>
        </p>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      show: {
        type: Boolean,
        required: true
      }
    },
    methods: {
      closeOverlay() {
        this.$emit('close');
      }
    }
  };
  </script>
  
  <style scoped>
  .overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
  }
  
  .overlay-content {
    text-align: center;
    color: white;
    font-size: 18px;
    line-height: 1.5;
    padding: 20px;
    background-color: rgba(0, 0, 0, 0.3);
    border-radius: 8px;
    max-width: 90%;
  }
  
  .overlay-content p {
    margin: 0;
  }
  
  .overlay-content .step {
    display: inline-flex;
    align-items: center;
    margin: 5px 0;
  }
  
  .overlay-content .step .circle {
    width: 24px;
    height: 24px;
    background-color: #007bff;
    border-radius: 50%;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-right: 10px;
    color: white;
    font-size: 14px;
  }
  
  .overlay-content .step .text {
    display: flex;
    align-items: center;
  }
  
  .overlay-content .step .text .icon {
    margin-right: 5px;
    width: 24px;
    height: 24px;
  }
  
  .arrow {
    margin-left: 5px; /* 调整箭头与图标的间距 */
  }
  </style>